import { Controller } from 'react-hook-form'
import NumberFormatterInput from './NumberFormatter'

export default ({
  name,
  control,
  label,
  defaultValue = '',
  disabled = false,
  validator = {}
}) => (
  <Controller
    name={name}
    control={control}
    defaultValue={defaultValue}
    render={({ field }) => (
      <>
        <label className={`input ${validator.hasError ? 'validator' : ''}`}
          {...(validator.hasError && validator.hasError(name) ? {'aria-invalid': true} : {})}
        >
          <span className="label">{label}</span>
          <NumberFormatterInput {...field} disabled={disabled} /> 
          <span className="label">m²</span>
        </label>
        {validator.getErrorMessage && (
          <div className="validator-hint hidden mt-0 empty:py-[0.6rem]">
            {validator.getErrorMessage(name)}
          </div>
        )}
      </>
    )}
  />
)